var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('KeywordFilter',{attrs:{"lookup":'zones/autocomplete'}}),_vm._v(" "),_c('div',{staticClass:"topbar__cell"},[_c('counters',[_c('template',{attrs:{"slot":"total"},slot:"total"},[_vm._v(_vm._s(_vm.zones.meta.total))])],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb8d1d76","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/zones/Topbar.vue
// module id = 1516
// module chunks = 65